import { TailSpin } from "react-loader-spinner";

export const CircularLoader = () => <TailSpin color="#00BFFF" height={80} width={80} />
